import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, Print } from "@mui/icons-material";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchSales, apiURL } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  getFromToDate4AcYear,
  validatedate_min_max,
  setDateChange,
  getlocalstoragedate,
  setlocalstoragedate,
  getRowData,
  setKeyboardShortcuts,
  csvFileName,
  getRowOfRT,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import SalesInvoiceSelection from "./SalesInvoiceSelection";
import CustomerDateWiseSales from "./CustomerDateWiseSales";
import ResetDate from "../images/resetdate.png";
import { json } from "react-router-dom";
import CtART from "./CustomTool/ResponsiveTable";

class SalesList extends Component {
  state = {
    Company: [],
    BillType: [],
    Customer: [],
    TransationType: [],
    PaymentMode: [],
    IntSignature_StampPrint: 0,
    ShipTo: [],
    SalesInvoiceDefaultPrint: "",
    ListType: [
      { Type: "Pending Invoice" },
      { Type: "All" },
      { Type: "Paid Invoice" },
    ],
    columnsdata: [
      { accessorKey: "dat_salesdateDMY", header: "Date" },
      { accessorKey: "vac_billtype", header: "Bill Type" },
      { accessorKey: "vac_billno", header: "Bill No" },
      { accessorKey: "vac_customer", header: "Customer" },
      { accessorKey: "vac_customershipto", header: "Ship To" },
      { accessorKey: "dec_discamt", header: "Discount Amt" },
      { accessorKey: "dec_taxable", header: "Taxable" },
      { accessorKey: "dec_cgst", header: "CGST" },
      { accessorKey: "dec_sgst", header: "SGST" },
      { accessorKey: "dec_igst", header: "IGST" },
      { accessorKey: "cs", header: "CS" },
      { accessorKey: "i", header: "I" },
      { accessorKey: "dec_grtotal", header: "Grand Total" },
      { accessorKey: "dec_tdsamount", header: "TDS Amount" },
      { accessorKey: "dec_advancepayment", header: "Adv.Payment" },
      { accessorKey: "dec_netpayment", header: "Net Payment" },
      { accessorKey: "vac_salestransactiontype", header: "Transaction Type" },
      { accessorKey: "vac_remark", header: "vac_remark" },
      { accessorKey: "bint_acid", header: "bint_acid" },
      { accessorKey: "vac_company", header: "vac_company" },
      { accessorKey: "bint_salessrno", header: "bint_salessrno" },
      { accessorKey: "bint_billno", header: "bint_billno" },
      { accessorKey: "bint_vouno", header: "bint_vouno" },
      { accessorKey: "dat_salesdate", header: "Date" },
      { accessorKey: "itemlist", header: "Item List" },
    ],
    // columns: [
    //   { id: "Action", label: "Search", name: "Search" },
    //   { id: "dat_salesdateDMY", label: "Date" },
    //   { id: "vac_billtype", label: "Bill Type" },
    //   { id: "vac_billno", label: "Bill No" },
    //   { id: "vac_customer", label: "Customer" },
    //   { id: "vac_customershipto", label: "Ship To" },
    //   { id: "dec_discamt", label: "Discount Amt" },
    //   { id: "dec_taxable", label: "Taxable" },
    //   { id: "dec_cgst", label: "CGST", hide: true },
    //   { id: "dec_sgst", label: "SGST", hide: true },
    //   { id: "dec_igst", label: "IGST", hide: true },
    //   { id: "cs", label: "CS" },
    //   { id: "i", label: "I" },
    //   { id: "dec_grtotal", label: "Grand Total" },
    //   { id: "dec_tdsamount", label: "TDS Amount" },
    //   { id: "dec_advancepayment", label: "Adv.Payment" },
    //   { id: "dec_netpayment", label: "Net Payment" },
    //   { id: "vac_salestransactiontype", label: "Transaction Type" },
    //   { id: "vac_remark", label: "vac_remark", hide: true },
    //   { id: "bint_acid", label: "bint_acid", hide: true },
    //   { id: "vac_company", label: "vac_company", hide: true },
    //   { id: "bint_salessrno", label: "bint_salessrno", hide: true },
    //   { id: "bint_billno", label: "bint_billno", hide: true },
    //   { id: "bint_vouno", label: "bint_vouno", hide: true },
    //   { id: "dat_salesdate", label: "Date", hide: true },
    //   { id: "itemlist", label: "Item List" },
    // ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "SalesList:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "SalesList:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Sales == "R" ||
          this.props.userPrivilege.Sales == "W",
      },
      {
        name: "Print Invoice",
        icon: <Print />,
        link: "SalesList:",
        actionType: "AlertResponsive",
        hide: this.props.userPrivilege.Sales == "R",
      },
    ],
    searchData: {
      dat_salesdate: "",
      vac_billtype: "",
      vac_billno: "",
      vac_customer: "",
      vac_customershipto: "",
      vac_salestransactiontype: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    keyColumn: [
      "dat_salesdate", //0
      "vac_billtype", //1
      "vac_billno", //2
      "vac_customer", //3
      "vac_customershipto", //4
      "dec_discamt", //5
      "dec_taxable", //6
      "dec_cgst", //7
      "dec_sgst", //8
      "dec_igst", //9
      "dec_grtotal", //10
      "dec_tdsamount", //11
      "dec_advancepayment", //12
      "dec_netpayment", //13
      "vac_salestransactiontype", //14
      "vac_remark", //15
      "bint_acid", //16
      "vac_company", //17
      "bint_salessrno", //18
      "bint_billno", //19
      "bint_vouno", //20
      "cs", //21
      "i", //22
      "itemlist", //23
    ],
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Sales List";
    this.props.setActiveMenu("SalesList");
    this.setSearchColumns();
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
    // setDateChange(e.target.name, e.target.value);
    // let Name = e.target.name
    // let Value = e.target.value
    // console.log("Name", Name);
    // if (e.target.name === 'dtpFromDate' || e.target.name === 'dtpToDate') {
    //   localStorage.setItem(e.target.name, e.target.value);
    // }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickAdd: this.handleOnNewEntryClick,
      }),
    });
  };
  navigateSalesEntry = (bint_acid, bint_salessrno, bint_acyear) => {
    // this.props.navigate("/SalesEntry", {
    //   state: {
    //     bint_acid: bint_acid,
    //     bint_salessrno: bint_salessrno,
    //     bint_acyear: bint_acyear,
    //   },
    // });
    this.props.navigateTo("Salesnew", {
      bint_acid: bint_acid,
      bint_salessrno: bint_salessrno,
      bint_acyear: bint_acyear,
    });
  };

  handleARDonActionClick = (row) => {
    console.log("row", row);
    const bint_acid = row.bint_acid,
      bint_salessrno = row.bint_salessrno,
      bint_acyear = localStorage.getItem("ACY"),
      actionName = row.actionName,
      vac_billno = row.vac_billno;
    if (actionName === "Edit") {
      // this.props.navigateTo(
      //   "SalesEntry/:" + bint_acid + ":" + bint_salessrno + ":" + bint_acyear
      // );
      this.navigateSalesEntry(bint_acid, bint_salessrno, bint_acyear);
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Bill No. : " + vac_billno + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteSalesList(
                bint_acid,
                bint_salessrno,
                bint_acyear
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else if (actionName === "Print Invoice") {
      // this.openInvoice(bint_acid, bint_acyear, vac_billno);
      this.openInvoiceARDSelection(vac_billno);
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_acid",
      "bint_salessrno",
      "vac_billno",
    ]);

    const bint_acid = row.bint_acid,
      bint_salessrno = row.bint_salessrno,
      bint_acyear = localStorage.getItem("ACY"),
      vac_billno = row.vac_billno;
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree="Delete"
          labelDisagree="Cancel"
          alertTitle={"Do you want to Delete Bill No. : " + vac_billno + " ?"}
          alertMessage=""
          handleOnClickYes={() => {
            return this.deleteSalesList(bint_acid, bint_salessrno, bint_acyear);
          }}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_acid", "bint_salessrno"]);
    const bint_acid = row.bint_acid,
      bint_salessrno = row.bint_salessrno,
      bint_acyear = localStorage.getItem("ACY");

    this.props.navigateTo("Salesnew", {
      bint_acid: bint_acid,
      bint_salessrno: bint_salessrno,
      bint_acyear: bint_acyear,
    });
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rowsCount > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.dat_salesdate.length === 0 ||
            (row["dat_salesdate"] &&
              row["dat_salesdate"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dat_salesdate.toLowerCase()
                ))) &&
          (this.state.searchData.vac_billtype.length === 0 ||
            (row["vac_billtype"] &&
              row["vac_billtype"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_billtype.toLowerCase()))) &&
          (this.state.searchData.vac_billno.length === 0 ||
            (row["vac_billno"] &&
              row["vac_billno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_billno.toLowerCase()))) &&
          (this.state.searchData.vac_customer.length === 0 ||
            (row["vac_customer"] &&
              row["vac_customer"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_customer.toLowerCase()))) &&
          (this.state.searchData.vac_customershipto.length === 0 ||
            (row["vac_customershipto"] &&
              row["vac_customershipto"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_customershipto.toLowerCase()
                ))) &&
          (this.state.searchData.vac_salestransactiontype.length === 0 ||
            (row["vac_salestransactiontype"] &&
              row["vac_salestransactiontype"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_salestransactiontype.toLowerCase()
                )))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnCusDateWiseSalesClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={<CustomerDateWiseSales />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };
  //#endregion handle

  //region function
  handleOnNewEntryClick = () => {
    this.removeKeyboardShortCuts();
    this.props.navigateTo("SalesNew");
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "dat_salesdate",
        label: "Date",
        value: this.state.searchData.dat_salesdate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_billtype",
        items: this.state.BillType,
        label: "Bill Type",
        value: this.state.searchData.vac_billtype,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_billno",
        label: "Bill No",
        value: this.state.searchData.vac_billno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_customer",
        items: this.state.Customer,
        label: "Customer Name",
        value: this.state.searchData.vac_customer,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_customershipto",
        items: this.state.ShipTo,
        label: "Ship To",
        value: this.state.searchData.vac_customershipto,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "Lbl",
        label: "Discount Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Taxable",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "CGST",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "SGST",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "IGST",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "CS",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "I",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "Grand Total",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "TDS Amount",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "Adv. Payment",
        width: "110",
      },
      {
        cType: "Lbl",
        label: "Net Amount",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_salestransactiontype",
        label: "Transaction Type",
        value: this.state.searchData.vac_salestransactiontype,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
      /* {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }, */
    );
    this.setState({ searchColumns }, () => {
      // console.log("this.state.searchColumns", this.state.searchColumns);
    });
  };

  validateSales = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;

    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter FromDate", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter ToDate", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else {
      result = true;
    }
    return result;
  };
  onFormLoad = () => {
    const { fromdate, todate } = getlocalstoragedate("Sales");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.getInfo();
      }
    );
  };

  getInfo = () => {
    if (this.validateSales()) {
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SalesList",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
        };
        fetchSales(reqData)
          .then((res) => {
            dataLoadStatus = true;
            let rows = res.data.SalesList,
              rowsCount = rows.length;
            let StrSignature_StampPrint = getRowData(
              res.data.GeneralSettingList,
              "vac_key",
              "In Sales (Default)"
            );
            let IntSignature_StampPrint = "",
              SalesInvoiceDefaultPrint = "";

            res.data.GeneralSettingList.map((row) => {
              if (row.vac_module === "Signature & Stamp") {
                if (row.vac_key === "In Sales (Default)") {
                  IntSignature_StampPrint =
                    StrSignature_StampPrint["vac_value"] === "Yes" ? 1 : 0;
                }
              }
            });
            res.data.InvoiceSettingList.map((row) => {
              SalesInvoiceDefaultPrint = row.vac_invoicepaper;
            });
            this.setState({
              dataLoadStatus,
              rows,
              rowsCount,
              IntSignature_StampPrint,
              SalesInvoiceDefaultPrint,
            });
            console.log("IntSignature_StampPrint", IntSignature_StampPrint);
          })
          .catch((error) => {
            console.log("Unknown error occurred in getInfo.", error);
          });
      });
      document.getElementById("dtpFromDate").focus();
    }
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "Sales",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      window.location.reload();
      this.onFormLoad();
    }
  };

  deleteSalesList = (bint_acid, bint_salessrno, bint_acyear) => {
    let dataLoadStatus = false;
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteSales",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_salessrno: bint_salessrno,
        dat_fromdate: this.state.formData.dtpFromDate,
        dat_todate: this.state.formData.dtpToDate,
      };
      fetchSales(reqData)
        .then((res) => {
          dataLoadStatus = true;
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState(
              {
                dataLoadStatus,
              },
              () => {
                this.getInfo();
              }
            );
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in deleteSalesList.", error);
        });
    });
    return true;
  };

  openInvoiceARDSelection = (row) => {
    const rows = getRowOfRT(row, ["bint_acid", "bint_salessrno", "vac_billno"]);
    const vac_billno = rows.vac_billno;
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close" // alertTitle={"Do you want to Delete Bill No. : " + vac_billno + " ?"}
          alertMessage={
            <SalesInvoiceSelection
              bint_acid={localStorage.getItem("acid")}
              bint_acyear={localStorage.getItem("ACY")}
              vac_billno={vac_billno}
              IntSignature_StampPrint={this.state.IntSignature_StampPrint}
              SalesInvoiceDefaultPrint={this.state.SalesInvoiceDefaultPrint}
            />
          }
          defaultOpenDialog={true}
        />
      );
      this.setState({ ARD });
    });
  };
  // openInvoice = (bint_acid, bint_acyear, vac_billno) => {
  //   this.props.notifyProcessing();
  //   let reqData = [
  //     { name: 'Op', value: 'SalesInvoicePrint' },
  //     { name: 'bint_acid', value: bint_acid },
  //     { name: 'bint_acyear', value: bint_acyear },
  //     { name: 'vac_billno', value: vac_billno },
  //   ]
  //   console.log("reqData", reqData);
  //   var form = document.createElement("form");
  //   form.setAttribute("method", "post");
  //   form.setAttribute("action", apiURL + "salesdetail.php");
  //   form.setAttribute("target", "view");
  //   reqData.forEach((data) => {
  //     var hiddenField = document.createElement("input");
  //     hiddenField.setAttribute("type", "hidden");
  //     hiddenField.setAttribute("name", data.name);
  //     hiddenField.setAttribute("value", data.value);
  //     form.appendChild(hiddenField);
  //     document.body.appendChild(form);
  //   });

  //   window.open("", "view");

  //   form.submit();
  //   this.props.updateProcessing("success", "PDF Open in next Tab.");
  // };

  openInvoice = (bint_acid, bint_acyear, vac_billno) => {
    this.props.notifyProcessing();
    let reqData = [
      { name: "Op", value: "SalesInvoicePrint" },
      { name: "bint_acyear", value: bint_acyear },
      { name: "bint_acid", value: bint_acid },
      { name: "vac_billno", value: vac_billno },
    ];

    // Create a query string from the request data
    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    // Set the URL of the popup window
    let popupURL = apiURL + "salesdetail.php?" + queryString;

    // Open the popup window
    window.open(
      popupURL,
      "SalesList",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
  };

  //#endregion handle

  getFinancialYearEndDateFromLocalStorage = () => {
    let dt = getFromToDate4AcYear(localStorage.getItem("ACY"));
    // console.log("dt", dt);
    // var intYear = localStorage.getItem("FullACY");
    // var firstDate = "1-APR-2023"
    // var lastDate ="31-MAR-2024"
    // console.log('Year:', intYear);
    // console.log('First Date:', firstDate);
    // console.log('Last Date:', lastDate);
  };

  // openInvoiceARDSelection = (rtRow) => {
  //   const row = getRowOfRT(rtRow, ["vac_billno"]);

  //   this.setState({ ARD: null }, () => {
  //     let ARD = (
  //       <AlertResponsiveDialog
  //         labelDisagree="Close"
  //         alertMessage=<SalesInvoiceSelection
  //           bint_acid={localStorage.getItem("acid")}
  //           bint_acyear={localStorage.getItem("ACY")}
  //           vac_billno={row.vac_billno}
  //         />
  //         defaultOpenDialog={true}
  //       />
  //     );
  //     this.setState({ ARD });
  //   });
  // };

  //#endregion handle

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Sales List</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: "inline-flex" }}>
                <CardContent style={{ paddingBottom: "0px" }}>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  nextCtrlID={"dtpToDate"}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.getInfo}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>

              <Grid item>
                <CtBtn label="Load" onClick={this.getInfo} variant="outlined" />
              </Grid>

              {/* <Grid item>
                <CtBtn
                  label="To Date"
                  onClick={this.handleOnCusDateWiseSalesClick}
                />
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
        <br />
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Sales Entry"
        /> */}

        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("SalesList")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            {
              label: "Delete",
              onClick: this.handleARDonActionClick_Delete,
              icon: "delete",
              className: "delete-button",
            },
            {
              label: "Print",
              onClick: this.openInvoiceARDSelection,
              icon: "print",
              className: "print-button",
            },
          ]}
          tableButtonAction={[
            {
              label: "Sales Entry",
              onClick: this.handleOnNewEntryClick,
              addPluseIcon: true,
            },
          ]}
          showColumnFilters={false}
          actionColSize={110}
          hideColIdList={[
            "dec_cgst",
            "dec_sgst",
            "dec_igst",
            "vac_remark",
            "bint_acid",
            "vac_company",
            "bint_salessrno",
            "bint_billno",
            "bint_vouno",
            "dat_salesdate",
          ]}
          density={"compact"}
        />

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(SalesList))));
